const Mai = ()=> {
    return (
      <div>
        <h5>MAI - Fantom blockchain situation</h5>
        <blockquote>
        Because of the multichain hack vault oracle prices on FANTOM are unreliable and thus the collateral prices are calculated as follow:
        <br/>
        <br/>
        collateral price = vault oracle price * 1inchPrice / coinGeckoPrice
          <footer>
            <cite>Risk DAO</cite>
          </footer>
        </blockquote>
      </div>
    )
  }
  
  export default Mai
  